import { FC, JSX, useContext } from "react";
import DashboardTile from "../../../shared/qes-standards/DashboardTile";
import EcdExportWrapper from "../Exports/EcdExportWrapper";
import { EcdGenerateReportContext } from "../contexts/EcdGenerateReportContext";
import { ModalLink } from "../../../shared/Modals";
import { QesIcon } from "../../../shared/icons/QESIcon";
import { QesIcons } from "../../../shared/icons/qesIcons";

interface EcdReportPreviewTileProps {
  tileContent: JSX.Element;
  title: string;
}

const EcdReportPreviewTile: FC<EcdReportPreviewTileProps> = (props: EcdReportPreviewTileProps) => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const comparerTitle = props.title.split("_")[0];

  function handleDeleteClick() {
    switch (comparerTitle) {
      case "FiltersPage":
        wizardContext.setIncludeFilterPage(false);
        break;
      case "AdequacyBreakdown":
        wizardContext.setIncludeAdequacyBreakdown(false);
        break;
      case "GapOverview":
        wizardContext.setIncludeGapOverview(false);
        break;
      case "CompositeFillableGaps":
        wizardContext.setIncludeCompositeFillableGaps(false);
        break;
      case "GapsByAge":
        wizardContext.setIncludeGapsByAge(false);
        break;
      case "Exceptions":
        wizardContext.setIncludeExceptions(false);
        break;
      case "TopSpecialties":
        wizardContext.setIncludeTopSpecialties(false);
        break;
      case "TopCounties":
        wizardContext.setIncludeTopCounties(false);
        break;
      case "LineOfBusiness":
        wizardContext.setIncludeLineOfBusiness(false);
        break;
      case "CountyStatus":
        wizardContext.setIncludeCountyStatus(false);
        break;
      default:
        break;
    }
  }

  return (
    <DashboardTile
      backgroundColor="white"
      headerElement={
        <ModalLink
          content={{
            body: `Are you sure you want to remove this page?`,
            cancelButtonText: "Cancel",
            confirmButtonAction: () => handleDeleteClick(),
            confirmButtonText: "Delete",
            title: `Remove Page`,
          }}
          testId="ecd-export-delete-preview"
          classNames="qes-button qes-button-secondary ecd-preview-button"
        >
          <QesIcon iconName={QesIcons.FontAwesome.Trash} height="16px" isDecorative={false} />
        </ModalLink>
      }
      title={
        <>
          <span>{props.title}</span>
        </>
      }
      widthClass="ecd-export__tile"
    >
      <div className={"ecd-export__preview-scale " + props.title.split("_")[0]}>
        <EcdExportWrapper showExpand={true} tileContent={props.tileContent} title={comparerTitle} />
      </div>
    </DashboardTile>
  )
}

export default EcdReportPreviewTile;

